import React from "react";

const AVAILABILITY_TYPES = [
  { field: "early", abbreviation: "E", label: "Early", className: "early" },
  { field: "late", abbreviation: "L", label: "Late", className: "late" },
  { field: "longday", abbreviation: "LD", label: "Long Day", className: "longday" },
  { field: "twilight", abbreviation: "Twi", label: "Twilight", className: "twilight" },
  { field: "night", abbreviation: "ND", label: "Night", className: "night" },
  { field: "evening", abbreviation: "Eve", label: "Evening", className: "evening" },
];

export const availabilityAbbreviations = (availability) => {
  return AVAILABILITY_TYPES.filter((type) => availability?.[type.field])
    .map((type) => type.abbreviation)
    .join(" ");
};

export const AvailabilityTypePills = ({ availability, showFullNames = false }) => {
  const selectedTypes = AVAILABILITY_TYPES.filter(
    (type) => availability?.[type.field],
  );
  if (selectedTypes.length === 0) return null;

  return (
    <span className="availability-type-pills">
      {selectedTypes.map((type) => (
        <span
          key={type.field}
          className={`availability-type-pill availability-type-pill-${type.className}`}
        >
          {showFullNames ? type.label : type.abbreviation}
        </span>
      ))}
    </span>
  );
};
